const ROUTES = {
    mainPage: {path: "/"},
    login: {path: "/login"},
    notificationViewer: {path: "/notification-viewer"},
    notificationViewerEmailLogs: {
        path: "/notification-viewer/:region/:environment/email-logs",
        exact: true,
    },
    notificationViewerMobilePush: {
        path: "/notification-viewer/:region/:environment/mobile-push",
        exact: true,
    },
    notificationViewerSlack: {
        path: "/notification-viewer/:region/:environment/slack",
        exact: true,
    },
    notificationViewerTeams: {
        path: "/notification-viewer/:region/:environment/teams",
        exact: true,
    },
    notificationViewerPage: {
        path: "/notification/:region/:environment/:type/:notificationId",
        exact: true,
    },
    errorPage: {path: "/error", exact: true},
};

export default ROUTES;
